import './js/main.js';

import './css/main.scss';

function importAll(r) {
	let images = {};
	r.keys().forEach((item) => { images[item.replace('./', '')] = r(item); });
    return images;
}

const images = importAll(require.context('./images/', true, /\.(png|jpe?g|svg)$/));
